import { EFinancialStatus } from 'app/shared/enums/financial-status.enum';
import { EPaymentType } from 'app/shared/enums/payment-type.enum';
import { Option } from 'app/shared/interfaces/option.interface';
import { UserModel } from './user.model';

export class FinanceModel {
    finance_id: Option<number>;

    sale_id: Option<number>;

    user_receiver_id: Option<number>;

    user_payer_id: Option<number>;

    user_receiver: Option<UserModel>;

    user_payer: Option<UserModel>;

    date: Option<Date>;

    competance_date: Option<Date>;

    value: Option<number>;

    negotiated_value: Option<number>;

    document_number: Option<string>;

    forecast_payment_type: Option<EPaymentType>;

    realized_payment_type: Option<EPaymentType>;

    description: Option<string>;

    date_payed: Option<Date>;

    installment: Option<number>;

    related_finance_id: Option<number>;

    financial_account_id: Option<number>;

    financial_account: Option<{ financial_account_id: number; title: string; group: string; operation: string; module: string; description: string }>;

    commission_available?: boolean | null;

    /** Preenchido quando a comissão foi revisada (edição ou em massa); vem da API. */
    commission_reviewed_at?: Date | string | null;

    is_first_sale?: boolean;

    constructor(data?: Partial<FinanceModel>) {
        this.finance_id = data?.finance_id ?? null;

        this.user_receiver_id = data?.user_receiver_id ?? null;

        this.user_payer_id = data?.user_payer_id ?? null;

        this.user_receiver = data?.user_receiver ?? null;

        this.user_payer = data?.user_payer ?? null;

        this.date = data?.date ?? null;

        this.competance_date = data?.competance_date ?? null;

        this.value = data?.value ?? null;

        this.negotiated_value = data?.negotiated_value ?? null;

        this.document_number = data?.document_number ?? null;

        this.forecast_payment_type = data?.forecast_payment_type ?? null;

        this.realized_payment_type = data?.realized_payment_type ?? null;

        this.description = data?.description ?? null;

        this.date_payed = data?.date_payed ?? null;

        this.installment = data?.installment ?? 1;

        this.sale_id = data?.sale_id ?? null;

        this.related_finance_id = data?.related_finance_id ?? null;

        this.financial_account_id = data?.financial_account_id ?? null;

        this.financial_account = data?.financial_account ?? null;

        this.commission_available = data?.commission_available ?? null;
        this.commission_reviewed_at = data?.commission_reviewed_at ?? null;
        this.is_first_sale = data?.is_first_sale ?? false;
    }

    get status(): EFinancialStatus {
        if (this.date_payed) {
            return EFinancialStatus.PAID;
        }

        if (this.date) {
            const forecastDate = new Date(this.date);
            const today = new Date();
            forecastDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);

            if (forecastDate < today) {
                return EFinancialStatus.OVERDUE;
            }
        }

        return EFinancialStatus.PENDING;
    }

    get wasPaid(): boolean {
        return this.status === EFinancialStatus.PAID;
    }
}
